import { useContext, useMemo } from "react";
import { RestaurantContext } from "../contexts/Restaurant";

export const useCommonHooks = () => {
  const { orderTypeList } = useContext(RestaurantContext);

  //orderType filter
  const availableDeliveryTypes = useMemo(()=>{
    const filteredDeliveryTypes = orderTypeList && orderTypeList?.data.filter(
      (order) => order.status === 'On'
    );
    return filteredDeliveryTypes
  },[orderTypeList]);

  //orderType pos
  const availableDeliveryTypesForOnline = useMemo(()=>{
    const filteredDeliveryTypes = orderTypeList && orderTypeList?.data.filter(
      (order) => {
        const orderTypeName = order.name?.toLowerCase();
        const checkOdT = orderTypeName === "takeaway" || orderTypeName === "delivery";
        return order.status === 'On' && (checkOdT)
      }
    );
    return filteredDeliveryTypes
  },[orderTypeList])

  return { availableDeliveryTypes, availableDeliveryTypesForOnline };
};